import { ObjectModel, Product } from '@types';

export const modelBelongsToProduct = (product: Product, model: ObjectModel) =>
    product.model_id === model.id || model.child_models.includes(product.model_id);
